import { Controller } from "stimulus";

import FroalaEditor from "froala-editor";
import "./froala-plugins";

console.log('🔍 Froala configuration controller file loaded!');
console.log('🔍 Controller class defined:', typeof Controller);

export default class extends Controller {
  static targets = ["editorWrapper", "editor"];

  connect() {
    console.log('🔍 Froala configuration controller INSTANCE created!');
    console.log('🔍 Froala config controller connecting...', this.element);
    console.log('🔍 Element HTML:', this.element.innerHTML);
    
    // Add a small delay to ensure DOM is fully rendered
    setTimeout(() => {
      console.log('🔍 Available targets after delay:', this.targets);
      console.log('🔍 Has editorWrapper target:', this.hasEditorWrapperTarget);
      console.log('🔍 Has editor target:', this.hasEditorTarget);
      console.log('🔍 Element HTML after delay:', this.element.innerHTML);
      
      if (!this.hasEditorWrapperTarget) {
        console.error("🚨 editorWrapper target not found in Stimulus controller!");
        console.log('🔍 Element HTML:', this.element.innerHTML);
        return;
      }

      // For configuration view, always initialize the editor immediately
      this.initializeEditor();
    }, 100);
  }



  initializeEditor() {
    console.log('🔍 Initializing editor...');
    
    this.fetchMergeTags(this.editorWrapperTarget)
      .then((mergeTags) => {
        console.log('🔍 Merge tags fetched, initializing Froala...');
        this.initializeFroala(this.editorWrapperTarget, mergeTags);
      })
      .catch((error) => {
        console.error("Failed to fetch merge tags:", error);
      });
  }

  initializeFroala(editorWrapper, liquidTags) {
    console.log('🔍 Initializing Froala with editorWrapper:', editorWrapper);
    console.log('🔍 ===== FROALA CONFIGURATION CONTROLLER =====');
    setTimeout(() => {
      const textArea = editorWrapper.querySelector(".froala");
      console.log('🔍 Found textarea:', textArea);

      if (!textArea) {
        console.error("🚨 Froala editor target not found inside editorWrapper!", editorWrapper);
        return;
      }

      if (textArea.dataset.froalaInitialized === "true") {
        console.log('🔍 Editor already initialized, skipping...');
        return;
      }

      let dropdownCommandName = null;
      let dropdownOptions = {};
      
      if (liquidTags && liquidTags.length > 0) {
        dropdownCommandName = `liquidTagDropdown_${Date.now()}`;
        dropdownOptions = liquidTags.reduce((options, tag, index) => {
          options[index] = tag.title;
          return options;
        }, {});
      }

      // Register fontSize and textColor for quick insert
      // Create custom dropdowns similar to liquid tag button
      FroalaEditor.RegisterQuickInsertButton('fontSize', {
        title: "Font Size",
        icon: 'fontSize',
        focus: true,
        callback: function() {
          const editor = this;
          console.log('🔧 Font size quick insert button clicked');
          
          // Prevent quick insert from hiding (same as liquid tag)
          if (editor.quickInsert) {
            editor.quickInsert._keepVisible = true;
            editor.quickInsert._allowHide = false;
          }
          
          // Ensure editor is focused (but don't restore selection here to avoid moving cursor)
          try {
            editor.events.focus();
          } catch (error) {
            console.log('Could not focus editor:', error);
          }
          
          const selection = editor.selection.get();
          let left = 0;
          let top = 0;
          
          if (selection && selection.range) {
            const range = selection.range;
            const rect = range.getBoundingClientRect();
            // Use viewport coordinates directly (position: fixed uses viewport coordinates)
            left = rect.left;
            top = rect.bottom;
          } else {
            const editorRect = editor.el.getBoundingClientRect();
            left = editorRect.left;
            top = editorRect.top;
          }
          
          // Ensure position is visible
          if (top === 0 || left === 0 || isNaN(top) || isNaN(left)) {
            const editorRect = editor.el.getBoundingClientRect();
            left = editorRect.left + (editorRect.width / 2);
            top = editorRect.top + 50;
          }
          
          const existingDropdown = document.querySelector('.font-size-quick-insert-dropdown');
          if (existingDropdown) {
            existingDropdown.remove();
          }
          
          const dropdown = document.createElement('div');
          dropdown.className = 'font-size-quick-insert-dropdown';
          dropdown.style.cssText = `
            position: fixed;
            background: white;
            border: 1px solid #ccc;
            border-radius: 4px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            z-index: 99999;
            padding: 8px;
            min-width: 150px;
            max-height: 300px;
            overflow-y: auto;
          `;
          
          const fontSizes = ['8', '9', '10', '11', '12', '14', '16', '18', '20', '24', '28', '32', '36', '48', '72'];
          fontSizes.forEach(size => {
            const option = document.createElement('div');
            option.style.cssText = `
              padding: 6px 12px;
              cursor: pointer;
              font-size: ${size}px;
              transition: background-color 0.2s;
            `;
            option.textContent = size + 'px';
            option.addEventListener('mouseenter', () => {
              option.style.backgroundColor = '#e9ecef';
            });
            option.addEventListener('mouseleave', () => {
              option.style.backgroundColor = 'transparent';
            });
            option.addEventListener('click', (e) => {
              e.stopPropagation();
              e.preventDefault();
              console.log('🔧 Applying font size:', size);
              
              // Remove dropdown first
              dropdown.remove();
              
              // Apply command at current cursor position
              try {
                // Save selection right before executing command to preserve cursor position
                const savedSelection = editor.selection.save();
                
                // Apply the font size command
                editor.commands.exec('fontSize', size);
                
                // Restore selection immediately after command to keep cursor in place
                editor.selection.restore(savedSelection);
              } catch (error) {
                console.error('Error applying font size:', error);
              }
              
              // Hide quick insert toolbar after selection
              if (editor.quickInsert) {
                editor.quickInsert._keepVisible = false;
                editor.quickInsert._allowHide = true;
                if (editor.quickInsert._originalHide) {
                  editor.quickInsert._originalHide();
                }
              }
            });
            dropdown.appendChild(option);
          });
          
          dropdown.style.left = left + 'px';
          dropdown.style.top = top + 'px';
          document.body.appendChild(dropdown);
          console.log('🔧 Font size dropdown created at:', left, top);
          
          setTimeout(() => {
            const closeHandler = (e) => {
              if (!dropdown.contains(e.target)) {
                dropdown.remove();
                document.removeEventListener('click', closeHandler);
                // Allow quick insert to hide
                if (editor.quickInsert) {
                  editor.quickInsert._keepVisible = false;
                  editor.quickInsert._allowHide = true;
                }
              }
            };
            document.addEventListener('click', closeHandler);
          }, 10);
        }
      });

      FroalaEditor.RegisterQuickInsertButton('textColor', {
        title: "Text Color",
        icon: 'textColor',
        focus: true,
        callback: function() {
          const editor = this;
          console.log('🔧 Text color quick insert button clicked');
          
          // Prevent quick insert from hiding (same as liquid tag)
          if (editor.quickInsert) {
            editor.quickInsert._keepVisible = true;
            editor.quickInsert._allowHide = false;
          }
          
          // Ensure editor is focused (but don't restore selection here to avoid moving cursor)
          try {
            editor.events.focus();
          } catch (error) {
            console.log('Could not focus editor:', error);
          }
          
          const selection = editor.selection.get();
          let left = 0;
          let top = 0;
          
          if (selection && selection.range) {
            const range = selection.range;
            const rect = range.getBoundingClientRect();
            // Use viewport coordinates directly (position: fixed uses viewport coordinates)
            left = rect.left;
            top = rect.bottom;
          } else {
            const editorRect = editor.el.getBoundingClientRect();
            left = editorRect.left;
            top = editorRect.top;
          }
          
          // Ensure position is visible
          if (top === 0 || left === 0 || isNaN(top) || isNaN(left)) {
            const editorRect = editor.el.getBoundingClientRect();
            left = editorRect.left + (editorRect.width / 2);
            top = editorRect.top + 50;
          }
          
          const existingDropdown = document.querySelector('.text-color-quick-insert-dropdown');
          if (existingDropdown) {
            existingDropdown.remove();
          }
          
          const dropdown = document.createElement('div');
          dropdown.className = 'text-color-quick-insert-dropdown';
          dropdown.style.cssText = `
            position: fixed;
            background: white;
            border: 1px solid #ccc;
            border-radius: 4px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            z-index: 99999;
            padding: 8px;
          `;
          
          const colors = [
            '#000000', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#d9d9d9', '#efefef', '#f3f3f3', '#ffffff',
            '#980000', '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#4a86e8', '#0000ff', '#9900ff', '#ff00ff',
            '#e6b8af', '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#c9daf8', '#cfe2f3', '#d9d2e9', '#ead1dc',
            '#dd7e6b', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8', '#b4a7d6', '#d5a6bd',
            '#cc4125', '#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6d9eeb', '#6fa8dc', '#8e7cc3', '#c27ba0',
            '#a61c00', '#cc0000', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3c78d8', '#3d85c6', '#674ea7', '#a64d79',
            '#85200c', '#990000', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#1155cc', '#0b5394', '#351c75', '#741b47',
            '#5b0f00', '#660000', '#783f04', '#7f6000', '#274e13', '#0c343d', '#1c4587', '#073763', '#20124d', '#4c1130'
          ];
          
          const grid = document.createElement('div');
          grid.style.cssText = 'display: grid; grid-template-columns: repeat(10, 1fr); gap: 2px;';
          
          colors.forEach(color => {
            const colorBox = document.createElement('div');
            colorBox.style.cssText = `
              width: 20px;
              height: 20px;
              background-color: ${color};
              border: 1px solid #ccc;
              cursor: pointer;
              transition: transform 0.1s;
            `;
            colorBox.addEventListener('mouseenter', () => {
              colorBox.style.transform = 'scale(1.2)';
            });
            colorBox.addEventListener('mouseleave', () => {
              colorBox.style.transform = 'scale(1)';
            });
              colorBox.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                console.log('🔧 Applying text color:', color);
                
                // Remove dropdown first
                dropdown.remove();
                
                // Apply command at current cursor position
                try {
                  // Save selection right before executing command to preserve cursor position
                  const savedSelection = editor.selection.save();
                  
                  // Apply the color command
                  const cmd = editor.commands.get('textColor') ? 'textColor' : 'foreColor';
                  editor.commands.exec(cmd, color);
                  
                  // Restore selection immediately after command to keep cursor in place
                  editor.selection.restore(savedSelection);
                } catch (error) {
                  console.error('Error applying text color:', error);
                }
                
                // Hide quick insert toolbar after selection
                if (editor.quickInsert) {
                  editor.quickInsert._keepVisible = false;
                  editor.quickInsert._allowHide = true;
                  if (editor.quickInsert._originalHide) {
                    editor.quickInsert._originalHide();
                  }
                }
              });
            grid.appendChild(colorBox);
          });
          
          dropdown.appendChild(grid);
          dropdown.style.left = left + 'px';
          dropdown.style.top = top + 'px';
          document.body.appendChild(dropdown);
          console.log('🔧 Text color dropdown created at:', left, top);
          
          setTimeout(() => {
            const closeHandler = (e) => {
              if (!dropdown.contains(e.target)) {
                dropdown.remove();
                document.removeEventListener('click', closeHandler);
                // Allow quick insert to hide
                if (editor.quickInsert) {
                  editor.quickInsert._keepVisible = false;
                  editor.quickInsert._allowHide = true;
                }
              }
            };
            document.addEventListener('click', closeHandler);
          }, 10);
        }
      });

      if (dropdownCommandName) {
        FroalaEditor.DefineIcon(dropdownCommandName, { NAME: "code", SVG_KEY: "tags" });
        FroalaEditor.RegisterCommand(dropdownCommandName, {
        title: "Insert Liquid Tag",
        type: "dropdown",
        focus: true,
        options: dropdownOptions,
        callback: function (cmd, value) {
          const index = parseInt(value, 10); 
          const selectedTag = liquidTags[index]?.value;
          
          try {
            this.selection.restore();
            const selection = this.selection.get();
            if (selection && selection.range) {
              const range = selection.range;
              const textNode = document.createTextNode(selectedTag);
              range.insertNode(textNode);
              range.setStartAfter(textNode);
              range.setEndAfter(textNode);
              this.selection.set(range);
            } else {
              this.html.insert(selectedTag);
            }
            setTimeout(() => {
              this.events.focus();
              this.selection.restore();
            }, 10);
          } catch (error) {
            this.html.insert(selectedTag);
          }
        }
      });

        FroalaEditor.RegisterQuickInsertButton(dropdownCommandName, {
        title: "Insert Liquid Tag",
        type: "quickInsert",
        icon: dropdownCommandName,
        focus: true,
        callback: function (event) {
          const editor = this;
          
          if (editor.quickInsert) {
            editor.quickInsert._keepVisible = true;
            editor.quickInsert._allowHide = false;
          }
          
          try {
            editor.events.focus();
          } catch (error) {
          }
          
          const selection = editor.selection.get();
          let left = 0;
          let top = 0;
          
          if (selection && selection.range) {
            const range = selection.range;
            const rect = range.getBoundingClientRect();
            left = rect.left;
            top = rect.bottom;
          } else {
            const editorRect = editor.el.getBoundingClientRect();
            left = editorRect.left;
            top = editorRect.top;
          }
          
          if (top === 0 || left === 0 || isNaN(top) || isNaN(left)) {
            const editorRect = editor.el.getBoundingClientRect();
            left = editorRect.left + (editorRect.width / 2);
            top = editorRect.top + 50;
          }
          
          const existingDropdown = document.querySelector('.liquid-tag-quick-insert-dropdown');
          if (existingDropdown) {
            existingDropdown.remove();
          }
          
          const dropdown = document.createElement('div');
          dropdown.className = 'liquid-tag-quick-insert-dropdown';
          dropdown.style.cssText = `
            position: fixed;
            background: white;
            border: 1px solid #ccc;
            border-radius: 4px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            z-index: 99999;
            padding: 8px;
            min-width: 200px;
            max-height: 300px;
            overflow-y: auto;
          `;
          
          const header = document.createElement('div');
          header.textContent = 'Select Liquid Tag';
          header.style.cssText = 'font-weight: bold; padding: 8px; border-bottom: 1px solid #eee; margin-bottom: 4px;';
          dropdown.appendChild(header);
          
          liquidTags.forEach((tag, index) => {
            const option = document.createElement('div');
            option.className = 'liquid-tag-option';
            option.style.cssText = `
              padding: 6px 12px;
              cursor: pointer;
              transition: background-color 0.2s;
            `;
            option.textContent = tag.title;
            option.addEventListener('mouseenter', () => {
              option.style.backgroundColor = '#e9ecef';
            });
            option.addEventListener('mouseleave', () => {
              option.style.backgroundColor = 'transparent';
            });
            option.addEventListener('click', (e) => {
              e.stopPropagation();
              e.preventDefault();
              
              dropdown.remove();
              
              try {
                const savedSelection = editor.selection.save();
                const selection = editor.selection.get();
                if (selection && selection.range) {
                  const range = selection.range;
                  const textNode = document.createTextNode(tag.value);
                  range.insertNode(textNode);
                  range.setStartAfter(textNode);
                  range.setEndAfter(textNode);
                  editor.selection.set(range);
                } else {
                  editor.html.insert(tag.value);
                }
                editor.selection.restore(savedSelection);
              } catch (error) {
                editor.html.insert(tag.value);
              }
              
              if (editor.quickInsert) {
                editor.quickInsert._keepVisible = false;
                editor.quickInsert._allowHide = true;
                if (editor.quickInsert._originalHide) {
                  editor.quickInsert._originalHide();
                }
              }
            });
            dropdown.appendChild(option);
          });
          
          dropdown.style.left = left + 'px';
          dropdown.style.top = top + 'px';
          document.body.appendChild(dropdown);
          
          setTimeout(() => {
            const closeHandler = (e) => {
              if (!dropdown.contains(e.target)) {
                dropdown.remove();
                document.removeEventListener('click', closeHandler);
                if (editor.quickInsert) {
                  editor.quickInsert._keepVisible = false;
                  editor.quickInsert._allowHide = true;
                }
              }
            };
            document.addEventListener('click', closeHandler);
          }, 10);
        }
      });
      }

      const tableBorderCommandName = 'tableBorderFormat';
      // Define icon using PATH with SVG path data for a hollow grid/table with borders
      // Rectangle outline (no fill) + grid lines
      FroalaEditor.DefineIcon(tableBorderCommandName, {
        PATH: 'M3 3h18v18h-18z M3 9h18 M3 15h18 M9 3v18 M15 3v18',
        fill: 'none'
      });
      
      console.log('✅ About to register table border format command...');
      
      FroalaEditor.RegisterCommand(tableBorderCommandName, {
        title: "Table Border Width",
        type: "dropdown",
        focus: false,
        undo: true,
        options: {
          '0': 'No Border (0px)',
          '0.5': 'Thin (0.5px)',
          '1': '1px',
          '2': '2px',
          '3': '3px',
          '4': '4px',
          '5': 'Thick (5px)'
        },
        callback: function (cmd, value) {
          console.log('🔍 Table border callback called with value:', value);
          const borderWidth = value === '0' ? '0' : value + 'px';
          const borderColor = '#ddd'; // Default border color
          
          const editor = this;
          
          let table = null;
          
          const selectedElement = editor.selection.element();
          console.log('🔍 Selected element:', selectedElement);
          
          if (selectedElement) {
            if (selectedElement.tagName === 'TABLE') {
              table = selectedElement;
            } else {
              table = selectedElement.closest('table');
            }
          }
          
          if (!table) {
            const selection = editor.selection.get();
            if (selection && selection.range) {
              let node = selection.range.commonAncestorContainer;
              if (node.nodeType !== 1) {
                node = node.parentElement;
              }
              if (node) {
                table = node.closest('table');
              }
            }
          }
          
          if (!table) {
            const editorElement = editor.$el[0] || editor.el;
            if (editorElement) {
              table = editorElement.querySelector('table');
            }
          }
          
          console.log('🔍 Found table:', table);
          
          if (!table || table.tagName !== 'TABLE') {
            console.error('❌ No table found to apply borders');
            return;
          }
          
          const cells = table.querySelectorAll('td, th');
          console.log('🔍 Applying borders to', cells.length, 'cells');
          
          cells.forEach(function(cell) {
            if (borderWidth === '0') {
              cell.style.border = 'none';
              cell.style.borderWidth = '0';
              cell.style.borderStyle = 'none';
              cell.removeAttribute('border');
            } else {
              cell.style.border = borderWidth + ' solid ' + borderColor;
              cell.style.borderWidth = borderWidth;
              cell.style.borderStyle = 'solid';
              cell.style.borderColor = borderColor;
            }
          });
          
          if (borderWidth === '0') {
            table.style.border = 'none';
            table.style.borderWidth = '0';
            table.style.borderStyle = 'none';
            table.removeAttribute('border');
          } else {
            table.style.border = borderWidth + ' solid ' + borderColor;
            table.style.borderWidth = borderWidth;
            table.style.borderStyle = 'solid';
            table.style.borderColor = borderColor;
          }
          
          table.style.borderCollapse = 'collapse';
          table.style.borderSpacing = '0';
          
          const currentHtml = editor.html.get();
          editor.html.set(currentHtml);
          
          editor.events.trigger('contentChanged', [], true);
          
          console.log('✅ Borders applied successfully');
        }
      });
      
      console.log('✅ Table border format command registered successfully!');
      console.log('🔍 Command available:', typeof FroalaEditor.COMMANDS[tableBorderCommandName] !== 'undefined');

      const isMobile = window.innerWidth <= 768;

      const mobileToolbar = {
        moreMisc:{
          buttons: [
            dropdownCommandName, 'bold', 'italic', 'fontSize', 'textColor', 'underline', 'undo', 'redo', 'clearFormatting', 'fullscreen', 'insertTable', tableBorderCommandName, 'fontFamily', 'backgroundColor', 'align', 'formatOL', 'formatUL', 'lineHeight', 'outdent', 'indent', 'quote', 'insertImage', 'insertVideo', 'embedly', 'insertLink', 'insertHR', 'print', 'selectAll'
          ],
          buttonsVisible : 8
        }
      };

      const froalaApiKey = document.querySelector('meta[name="froala-api-key"]')?.content;

      console.log('🔍 Creating Froala editor instance...');
      new FroalaEditor(textArea, {
        key: froalaApiKey,
        theme: 'dark',
        dragInline: false,
        attribution: false,
        toolbarSticky: false,
        toolbarInline: true,
        toolbarVisibleWithoutSelection: false,
        charCounterCount: false,
        wordCounterCount: false,
        height: 120,
        heightMin: 120,
        heightMax: null,
        imageUpload: true,
        imageUploadURL: '/froala_file_uploader',
        imageUploadParams: {
          authenticity_token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        fileUpload: true,
        fileUploadURL: '/froala_file_uploader',
        fileUploadParams: {
          authenticity_token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        imageResize: true,
        imageResizeWithPercent: true,
        imageEditButtons: ['imageStyle', 'imageAlign', 'imageDisplay', 'imageAlt', 'imageSize', 'imageLink', 'imageRemove'],

        tableEditButtons: ['tableHeader', 'tableRemove', 'tableRows', 'tableColumns', 'tableCells', 'tableCellBackground', 'tableCellVerticalAlign', 'tableCellHorizontalAlign', tableBorderCommandName],

        toolbarButtons: mobileToolbar,
  
        fileUploadMethod: 'POST',
        imageUploadMethod: 'POST',

        quickInsertEnabled: true,
        quickInsertButtons: dropdownCommandName ? [dropdownCommandName, 'image', 'table', 'insertLink', 'ol', 'ul', 'hr', 'quote', 'video', 'code'] : ['image', 'table', 'insertLink', 'ol', 'ul', 'hr', 'quote', 'video', 'code'],
        quickInsertTags: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre', 'blockquote', 'li', 'td', 'th'], // Allow quick insert in all these tags even with content

        // Enable plugins including fontSize and colors
        pluginsEnabled: ['mentions', 'link', 'quickInsert', 'image', 'table', 'lists', 'quote', 'code_view', 'video', 'hr', 'fontSize', 'colors'],

        events: {
          'initialized': function () {
            console.log('🔍 Froala editor initialized successfully!');
            textArea.dataset.froalaInitialized = "true"; // Mark as initialized
            this.el.style.fontFamily = 'realist, arial, sans-serif';
            this.el.style.fontSize = '18px';
            this.el.style.color = '#575F67';
            
            console.log('🔍 Table edit buttons configured:', this.opts.tableEditButtons);
            console.log('🔍 Table border command registered:', typeof this.commands.get('tableBorderFormat') !== 'undefined');
          },
          'table.click': function(table) {
            console.log('🔍 Table clicked, table edit toolbar should appear');
            console.log('🔍 Available table edit buttons:', this.opts.tableEditButtons);
          },
          'focus': function () {
            console.log('🔍 Editor focused, should be editable now');
          },
          'commands.after': function (cmd) {
            if (cmd === 'findReplaceButton') {
              setTimeout(() => {
                const editorBox = this.$box.get(0);
                const frView = document.querySelector('.fr-element.fr-view');

                // Safely get clean HTML without highlight spans
                const getCleanHtml = () =>
                  frView?.innerHTML
                    .replace(/<span class="fr-find-replace-highlight">/g, "")
                    .replace(/<span class="fr-find-replace-highlight fr-find-replace-current-highlight">/g, "")
                    .replace(/<\/span>/g, "");

                const updateTextArea = () => {
                  if (textArea && frView) {
                    textArea.value = getCleanHtml();
                  }
                };

                // Map buttons to their selectors
                const buttons = {
                  findBtn: '.fr-find-btn',
                  replaceBtn: '.fr-replace-btn',
                  replaceAllBtn: '.fr-replace-all-btn',
                  closeBtn: '.fr-close-btn',
                  advancedOptionBtn: '.fr-toggle-advanced-options',
                  arrowDownBtn: '.fa.fa-chevron-down',
                  arrowUpBtn: '.fa.fa-chevron-up'
                };

                Object.entries(buttons).forEach(([key, selector]) => {
                  const btn = editorBox.querySelector(selector);
                  if (btn) {
                    btn.addEventListener("click", (e) => {
                      e.preventDefault();
                      console.log("Updating from:", selector);
                      updateTextArea();
                    });
                  }
                });
              }, 100); // Wait for DOM to be ready
            }
          },
          'image.beforeUpload': function (files) {
            console.log("🖼️ Image selected for upload:", files);
            customFileUpload(files[0], this, "image");
            return false; // Prevent Froala's default upload
          },
          'image.beforePasteUpload': function (img) {
            console.log("🛑 Preventing default pasted image insertion");
            detectAndUploadBase64Images(this);
            return false; // Prevent automatic base64 image insertion
          },
          'file.beforeUpload': function (files) {
            console.log("📄 File selected for upload:", files);
            customFileUpload(files[0], this, "file");
            return false; // Prevent Froala's default upload
          },
          'image.inserted': function ($img, response) {
            console.log("✔️ Image inserted into editor", $img, response);
            // Resize inserted images to max 500px width
            resizeImageToMaxWidth($img, 500);
          },
          'paste.after': function () {
            // Handle URL to link conversion and image resize after paste
            const editor = this;
            setTimeout(() => {
              // Convert URLs to links
              convertUrlsToLinks(editor);
              // Resize any pasted images
              resizePastedImages(editor, 500);
            }, 100);
          },
          'destroy': function () {
            delete textArea.dataset.froalaInitialized; // Reset on destroy
          }
        }
      });
    }, 0);
  }

  fetchMergeTags(editorWrapper) {
    console.log('🔍 Fetching merge tags for editorWrapper:', editorWrapper);
    return new Promise((resolve, reject) => {
      const textArea = editorWrapper.querySelector(".froala");
      console.log('🔍 Found textarea in fetchMergeTags:', textArea);
      const container = textArea.closest('.rich-text-container');
      console.log('🔍 Found container in fetchMergeTags:', container);
      if (!container) return reject(new Error("Rich text container not found."));

      const { accountId, projectId, taskListId, taskId, blockId, processTemplateId, contentType } = container.dataset;
      let url;

      if (taskId) {
        url = `/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/get_liquid_tags?block_id=${blockId}&content_type=${contentType}`;
      } else if (processTemplateId) {
        url = `/${accountId}/process_templates/${processTemplateId}/get_liquid_tags?block_id=${blockId}&content_type=${contentType}`;
      } else if (taskListId) {
        url = `/${accountId}/projects/${projectId}/task_lists/${taskListId}/get_liquid_tags`;
      } else if (projectId) {
        url = `/${accountId}/projects/${projectId}/get_liquid_tags`;
      }
      else {
        url = `/${accountId}/client_assignments/get_liquid_tags`;
      }

      fetch(url, {
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").content
        }
      })
        .then(response => response.ok ? response.json() : Promise.reject(response.status))
        .then(data => resolve(data.map(tag => ({ value: tag[1], title: tag[0] }))))
        .catch(reject);
    });
  }
}

function customFileUpload(file, editor, type) {
  const reader = new FileReader();
  reader.onload = function (event) {
    const formData = new FormData();
    formData.append("authenticity_token", document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
    formData.append("file", file);

    fetch(editor.opts.imageUploadURL, {
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log("Upload response:", data);
        if (data.success) {
          editor.selection.restore();

          if (type === "image") {
            // Insert a placeholder image with the SGID stored in a data attribute
            const imageTag = `<img src="${data.link}" data-attachment-sgid="${data.attachment_sgid}" />`;
            editor.html.insert(imageTag);
          }

          console.log("✅ File uploaded successfully:", data);
        } else {
          console.error("❌ Upload failed:", data.error);
        }
      })
      .catch(error => {
        console.error("❌ Error uploading file:", error);
      });
  };
  reader.readAsDataURL(file);
}

function detectAndUploadBase64Images(editor) {
  const images = editor.el.querySelectorAll("img");

  images.forEach((img) => {
    if (img.src.startsWith("data:image")) {
      uploadBase64Image(img.src)
        .then((uploadedImageUrl) => {
          img.src = uploadedImageUrl;
          // Resize uploaded image to max 500px width
          resizeImageToMaxWidth(img, 500);
        })
        .catch((error) => console.error("Image upload failed", error));
    } else {
      // Resize existing images to max 500px width
      resizeImageToMaxWidth(img, 500);
    }
  });
}

async function uploadBase64Image(base64Data) {
  const response = await fetch("/upload_binary_image", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
    },
    body: JSON.stringify({ image: base64Data }),
  });

  if (!response.ok) throw new Error("Failed to upload image");
  const data = await response.json();
  return data.url;
}

// Function to resize image to maximum width while maintaining aspect ratio
function resizeImageToMaxWidth(img, maxWidth) {
  if (!img || !img.complete) {
    // Wait for image to load
    img.onload = function() {
      resizeImageToMaxWidth(img, maxWidth);
    };
    return;
  }
  
  if (img.naturalWidth > maxWidth) {
    const aspectRatio = img.naturalHeight / img.naturalWidth;
    img.style.maxWidth = maxWidth + 'px';
    img.style.width = maxWidth + 'px';
    img.style.height = 'auto';
    // Remove width/height attributes to use CSS instead
    img.removeAttribute('width');
    img.removeAttribute('height');
  }
}

// Function to resize all pasted images in the editor
function resizePastedImages(editor, maxWidth) {
  const images = editor.el.querySelectorAll("img");
  images.forEach((img) => {
    resizeImageToMaxWidth(img, maxWidth);
  });
}


function isPartOfEmail(text, matchIndex, url) {
  if (matchIndex < 0 || matchIndex >= text.length) return false;
  
  
  const before = matchIndex > 0 ? text[matchIndex - 1] : '';
  
  
  const lookbackStart = Math.max(0, matchIndex - 100);
  const textBefore = text.substring(lookbackStart, matchIndex);
  
  if (textBefore.includes('@')) {
    const emailPart = textBefore.substring(textBefore.lastIndexOf('@') + 1);
    if (emailPart.trim().length === 0 || emailPart.trim() === url.substring(0, emailPart.trim().length)) {
      return true;
    }
  }
  
  return before === '@';
}

function isValidDomainUrl(url) {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return true;
  }
  
  let domain = url.replace(/^https?:\/\//, '').replace(/^www\./, '');
  
  domain = domain.split('/')[0];
  
  if (!domain.includes('.')) {
    return false;
  }
  
  const parts = domain.split('.');
  
  if (parts.length < 2) {
    return false;
  }
  
  const compoundTlds = new Set([
    'co.uk', 'com.au', 'co.nz', 'co.in', 'com.pk', 'co.za', 'com.br', 'com.mx',
    'co.jp', 'com.cn', 'co.kr', 'com.sg', 'com.hk', 'com.tw', 'com.my', 'com.ph',
    'co.th', 'com.vn', 'com.id', 'co.id', 'net.au', 'org.uk', 'gov.uk', 'ac.uk',
    'ltd.uk', 'plc.uk', 'net.nz', 'org.nz', 'gov.au', 'edu.au', 'asn.au', 'id.au'
  ]);
  
  if (parts.length >= 2) {
    const lastTwo = parts.slice(-2).join('.').toLowerCase();
    if (compoundTlds.has(lastTwo)) {
      return true;
    }
  }
  
  const tld = parts[parts.length - 1].toLowerCase();
  
  
  const validCcTlds = new Set([
    'us', 'uk', 'pk', 'de', 'fr', 'in', 'au', 'ca', 'cn', 'jp', 'sa', 'ae', 'eu', 'it', 'es', 'nl',
    'se', 'no', 'fi', 'dk', 'ch', 'at', 'be', 'pl', 'cz', 'ie', 'pt', 'gr', 'ro', 'hu', 'bg', 'hr',
    'sk', 'si', 'ee', 'lv', 'lt', 'lu', 'mt', 'cy', 'co', 'mx', 'br', 'ar', 'cl', 'pe', 'za',
    'ng', 'eg', 'ke', 'ma', 'tn', 'dz', 'ly', 'sd', 'et', 'ug', 'tz', 'gh', 'ci', 'sn', 'cm', 'ao',
    'mz', 'zw', 'bw', 'na', 'zm', 'mg', 'mu', 'sc', 'km', 'dj', 'er', 'so', 'rw', 'bi', 'td', 'ne',
    'ml', 'bf', 'sl', 'lr', 'tg', 'bj', 'mr', 'gm', 'gw', 'gn', 'cv', 'st', 'gq', 'ga', 'cg', 'cd',
    'cf', 'td', 'kh', 'la', 'mm', 'bn', 'sg', 'my', 'id', 'ph', 'vn', 'th', 'bd', 'lk', 'mv', 'np',
    'bt', 'mn', 'kz', 'uz', 'tj', 'tm', 'kg', 'af', 'ir', 'iq', 'sy', 'jo', 'lb', 'il', 'ps', 'ye',
    'om', 'qa', 'bh', 'kw', 'ae', 'tr', 'az', 'ge', 'am', 'by', 'ua', 'md', 'ru', 'is', 'fo', 'gl',
    'gi', 'ad', 'mc', 'sm', 'va', 'li', 'je', 'gg', 'im', 'ax', 'io', 'tv', 'cc', 'ws', 'as', 'gu',
    'mp', 'pr', 'vi', 'vg', 'ky', 'bm', 'fk', 'gs', 'sh', 'tc', 'pf', 'nc', 'pn', 'nf', 'cx', 'hm',
    'aq', 'tf', 'gf', 'gp', 'mq', 're', 'yt', 'pm', 'bl', 'mf', 'sx', 'cw', 'bq', 'aw', 'sj', 'eh'
  ]);
  
  if (tld.length === 2) {
    return validCcTlds.has(tld);
  }
  
  const validGenericTlds = new Set([
    'com', 'org', 'net', 'edu', 'gov', 'mil', 'int', 'info', 'biz', 'name', 'pro',
    'aero', 'coop', 'museum', 'jobs', 'mobi', 'travel', 'tel', 'asia', 'cat',
    'xxx', 'post', 'geo', 'app', 'dev', 'io', 'tech', 'online', 'site', 'website',
    'store', 'shop', 'blog', 'news', 'media', 'tv', 'me', 'cc', 'ws', 'ly', 'ai'
  ]);
  
  return validGenericTlds.has(tld);
}

// Function to convert URLs in text to links
function convertUrlsToLinks(editor) {
  const editorElement = editor.el;
  const textNodes = getTextNodes(editorElement);
  
  const isAlphaNumericUnicode = (char) => /[\p{L}\p{N}]/u.test(char);
  
  textNodes.forEach((textNode) => {
    const text = textNode.textContent;
    
  
    const urlRegex = /(https?:\/\/[^\s<>"']+|www\.(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\/[^\s<>"']*)?|(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\/[^\s<>"']*)?)/gi;
    
    let match;
    const matches = [];
    const matchIndices = [];
    
    // Collect all matches with their indices
    while ((match = urlRegex.exec(text)) !== null) {
      let url = match[0];
      const matchIndex = match.index;
      
      // Strip trailing punctuation (periods, commas, etc.) before validation
      url = url.replace(/[.,;:!?]+$/, '');
      
      // Boundary check: reject if preceded or followed by word character (Unicode-safe)
      const charBefore = matchIndex > 0 ? text[matchIndex - 1] : '';
      const charAfter = matchIndex + url.length < text.length ? text[matchIndex + url.length] : '';
      
      // Reject if glued to letters/numbers (must be separated by space, punctuation, or start/end)
      if (charBefore && isAlphaNumericUnicode(charBefore)) {
        continue; // Skip matches that are mid-word
      }
      if (charAfter && isAlphaNumericUnicode(charAfter)) {
        continue; // Skip matches that are followed by word characters
      }
      
      matches.push(url);
      matchIndices.push(matchIndex);
    }
    
    if (matches.length > 0) {
      let newHTML = text;
      
      // Process matches in reverse order to preserve indices
      for (let i = matches.length - 1; i >= 0; i--) {
        const url = matches[i];
        const matchIndex = matchIndices[i];
        
        // Validation flow (correct order - DO THIS EXACTLY):
        // 1. Reject if already inside a link
        let parent = textNode.parentNode;
        let isInsideLink = false;
        while (parent && parent !== editorElement) {
          if (parent.tagName === 'A') {
            isInsideLink = true;
            break;
          }
          parent = parent.parentNode;
        }
        
        if (isInsideLink) continue;
        
        // 2. Reject if part of email address (CRITICAL)
        if (isPartOfEmail(text, matchIndex, url)) continue;
        
        // 3. Reject if mid-word boundary (already checked during collection, but double-check)
        const charBefore = matchIndex > 0 ? text[matchIndex - 1] : '';
        const charAfter = matchIndex + url.length < text.length ? text[matchIndex + url.length] : '';
        if (charBefore && isAlphaNumericUnicode(charBefore)) continue;
        if (charAfter && isAlphaNumericUnicode(charAfter)) continue;
        
        
        const isValidUrl = isValidDomainUrl(url);
        
        if (isValidUrl) {
          // Ensure URL has protocol
          let fullUrl = url;
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            fullUrl = 'https://' + url;
          }
          
          // Replace URL with link (open in new window by default)
          const linkHTML = `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
          
          // Replace from the specific index to preserve other matches
          const beforeMatch = newHTML.substring(0, matchIndex);
          const afterMatch = newHTML.substring(matchIndex + url.length);
          newHTML = beforeMatch + linkHTML + afterMatch;
        }
      }
      
      if (newHTML !== text) {
        // Create a temporary container to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newHTML;
        
        // Replace the text node with the new content
        const parent = textNode.parentNode;
        while (tempDiv.firstChild) {
          parent.insertBefore(tempDiv.firstChild, textNode);
        }
        parent.removeChild(textNode);
      }
    }
  });
  
  // Update Froala's internal HTML
  editor.html.set(editor.html.get());
}

// Helper function to get all text nodes in an element
function getTextNodes(element) {
  const textNodes = [];
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: function(node) {
        // Skip text nodes that are inside links
        let parent = node.parentNode;
        while (parent && parent !== element) {
          if (parent.tagName === 'A') {
            return NodeFilter.FILTER_REJECT;
          }
          parent = parent.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    }
  );
  
  let node;
  while (node = walker.nextNode()) {
    textNodes.push(node);
  }
  
  return textNodes;
}
